/* unplugin-vue-components disabled */import { render } from "./chip.vue?vue&type=template&id=3883d563&scoped=true"
import script from "./chip.vue?vue&type=script&lang=js"
export * from "./chip.vue?vue&type=script&lang=js"

import "./chip.vue?vue&type=style&index=0&id=3883d563&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3883d563"],['__file',"src/components/content-editable/chip.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3883d563"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3883d563', __exports__)) {
    api.reload('3883d563', __exports__)
  }
  
  module.hot.accept("./chip.vue?vue&type=template&id=3883d563&scoped=true", () => {
    api.rerender('3883d563', render)
  })

}


export default __exports__